import { useVerifyEmail } from '../../model'
import { AuthTabs } from '../shared/AuthTabs'
import { VerifyEmailForm } from './VerifyEmailForm'
import { Spinner } from '@/common/ui/Spinner'
import type { AxiosError } from 'axios'

export const VerifyEmail = () => {
    const { mutation } = useVerifyEmail()

    const errorMessage =
        mutation.isError && mutation.error
            ? (mutation.error as AxiosError<{ detail?: string }>)?.response?.data?.detail ||
              'Не удалось подтвердить email. Проверьте ссылку или обратитесь в поддержку.'
            : null

    return (
        <>
            <div>
                <AuthTabs />
            </div>
            <div className='w-full gap-[1.875rem] flex flex-col'>
                <div className='flex flex-col items-center gap-2 my-[1.875rem]'>
                    <h2 className='text-2xl text-center'>Подтверждение email</h2>
                </div>
                {mutation.isError && (
                    <div className='items-center'>
                        <p className='mb-[1.875rem]'>Ошибка подтверждения: {errorMessage}</p>
                        <VerifyEmailForm />
                    </div>
                )}
                {mutation.isPending && (
                    <div className='flex justify-center items-center h-[100px]'>
                        <Spinner />
                    </div>
                )}
                {mutation.isSuccess && (
                    <div className='items-center'>
                        <p>Email подтвержден</p>
                        <p>Ваш email адрес успешно подтвержден. Перенаправляем вас...</p>
                    </div>
                )}
            </div>
        </>
    )
}
